<template>
  <div class="c-favorite">
    <h1 class="c-favorite--heading">
      <img :src="require('@/assets/icon-access-history.png')">
      最近見た物件
    </h1>
    <loading v-if="!isReady"/>
    <div v-else>
      <div class="c-favorite__headArea">
        <div class="c-favorite__headAreaInner">
          <p class="c-favorite--count">{{count}}件</p>
          <button  v-if="count > 0" class="c-favorite--alldelete" @click="deleteAll"><img :src="require('@/assets/icon-trash-can.png')">全て削除する</button>
        </div>
        <p class="c-favorite__headText">
          ※掲載が終了した物件は、自動的に一覧から無くなります。
        </p>
      </div>
      <ul v-if="count > 0" class="c-favorite--list">
        <li class="c-favorite--list--item" v-for="(item, index) in propertyList" :key="index">
          <common-property-card class="c-favorite--list--item__card" :propdata="item" />
          <div class="c-favorite--list--item__block">
            <div class="c-favorite--list--item__block__button">
              <common-button
                v-if="item.contact_tel"
                :title="`${item.contact_tel}`"
                :type="'link'"
                :link_url="`tel:${item.contact_tel}`"
                :large="true"
                :width="'100%'"
                :border_red_text_black="true"
                :color_red_text="true"
                :font_size="'20px'"
                :font_bold="true"
                :icon="'icon_phone_call'" />
              <common-button
                :title="'資料請求する'"
                :type="'link'"
                :link_url="`/document-request/${item.id}`"
                :large="true"
                :width="'100%'"
                :border_red_text_black="true"
                :color_red_text="true"
                :font_size="'16px'"
                :icon="'icon-mail'"
                :label="'無料'" />
              <common-button
                :title="'見学予約する'"
                :type="'link'"
                :link_url="`/reservation/${item.id}`"
                :large="true"
                :width="'100%'"
                :border_red_text_black="true"
                :color_red_text="true"
                :font_size="'16px'"
                :icon="'icon-calendar-red'"
                :label="'無料'" />
              <div class="c-favorite__favButtonArea">
                <img
                    v-if="item.isBalloon"
                    class="c-favorite__balloon"
                    :src="require('@/assets/images/balloon/fav.png')"
                  />
                <common-button
                  v-if="!item.isAdded"
                  :title="'お気に入りに追加'"
                  :large="true"
                  :width="'100%'"
                  :font_size="'14px'"
                  :callback="toggleFavorite"
                  :attr=[index]
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :icon="!item.isAdded ? 'icon-favorite' : 'favorite-selected'" />
                <common-button
                  v-else
                  :title="'お気に入りに済み'"
                  :large="true"
                  :width="'100%'"
                  :border_red_text_black="true"
                  :color_red_text="true"
                  :font_size="'14px'"
                  :callback="toggleFavorite"
                  :attr=[index]
                  :icon="'favorite-selected'" />
              </div>
            </div>
            <span class="c-favorite--list--item__block__media"></span>
            <!-- <span class="c-favorite--list--item__block__delete" @click="deleteItem(item.id)"><img :src="require('@/assets/icon-trash-can.png')">削除する</span> -->
            <span class="c-favorite--list--item__block__provided">情報提供日：{{isDateFormated(item.provided_at)}}</span>
            <span class="c-favorite--list--item__block__update">次回更新日：情報提供より14日以内に更新</span>
          </div>
        </li>
      </ul>
      <common-pager
        :update="updatePage"
        :size="pageSize"
        :count="count"
        :page="page"
        />

    </div>
    <div v-if="count <= 0" class="c-favorite--noprops">最近見た物件はありません</div>
  </div>
</template>

<script>
import MixinUtil from '@/plugins/mixin-utils';
import IsMobileMixin from '@/plugins/isMobile';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import MixinAPI from '@/plugins/mixin-api';
import MixinMeta from '@/plugins/mixin-meta';

import CommonPropertyCard from '@/components/parts/CommonPropertyCard';
import CommonButton from '@/components/parts/button/CommonButton';
import CommonPager from '@/components/common/Pager';
import Loading from '@/components/common/Loading';

const querystring = window.location.search;
const query = [...new URLSearchParams(querystring).entries()]
  .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});

export default {
  name: 'ViewHistoryContents',
  mixins: [MixinUtil, IsMobileMixin, MixinAPI, BehaviorLogMixin, MixinMeta],
  components: {
    CommonPager,
    CommonPropertyCard,
    CommonButton,
    Loading,
  },
  data() {
    return {
      propertyList: [],
      viewHistoryList: [],
      page: 1,
      count: 0,
      pageSize: 10,
      isReady: false,
    };
  },
  mounted() {
    // fav
    // this.list = this.storedFavorite.data;
    // if (this.list === null) this.list = [];
    // if (this.list.length > 0) this.isAdded = this.list.find(n => n.id.toString() === this.propData.id.toString()) !== undefined;
  },
  watch: {
    // eslint-disable-next-line func-names
    '$store.state.view': function (newValue) {
      this.updateData(newValue);
    },
  },
  computed: {
    storedFavorite() {
      return this.$store.getters['getFavorite'];
    },
    storedViewHistory() {
      return this.$store.getters['getViewHistory'];
    },
  },
  async created() {
    this.metaSetForDefault('viewHistory');
    const page = query.page ? parseInt(query.page, 10) : 1;
    if (this.viewHistoryList === null) this.viewHistoryList = [];
    await this.fetchProperties(page);
    this.isReady = true;
    this.list = this.storedFavorite;
    this.hoge = this.propertyList.map((n, l) => {
      const ret = this.list.data.filter(m => m.id === n.id);
      this.propertyList[l].isAdded = ret.length > 0;
      this.propertyList[l].isBalloon = false;
      return this.propertyList[l];
    });
    this.propertyList = this.hoge;
    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
  },
  methods: {
    toggleFavorite(index) {
      const propData = this.propertyList[index];
      if (this.list === null) this.list = [];
      if (!this.propertyList[index].isAdded) {
        this.addWishList({
          id: propData.id,
          pageName: propData.name,
          oldPriceMin: +propData.price_min,
          oldPriceMax: +propData.price_max,
        });
        this.$set(this.propertyList, index, {
          ...this.propertyList[index], isAdded: true, isBalloon: true,
        });
        setTimeout(() => {
          this.$set(this.propertyList, index, {
            ...this.propertyList[index], isBalloon: false,
          });
        }, 3000);
      } else {
        this.$set(this.propertyList, index, {
          ...this.propertyList[index], isAdded: false,
        });
        this.deleteWishList(propData.id);
      }
    },
    async deleteItem(propertyId) {
      await this.deleteAccessLog(propertyId);
    },
    async deleteAll() {
      await this.deleteAllSiteAccessLogs();
    },
    async fetchProperties(page) {
      await this.retrieveSiteAccessLogs(page);

      // optimize -- only retrieve properties that we do not have after delete
      const propertiesToQuery = this.viewHistoryList.filter(item => !this.propertyList.map(i => i.id).includes(item.id));

      const fetchPromises = propertiesToQuery.map(async (a) => {
        try {
          return await this.getPropertyData(a.id);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(`Failed to retrieve property with id ${a.id}`);
          throw e;
        }
      });
      const finished = await Promise.allSettled(fetchPromises);
      this.propertyList = finished.filter(promise => promise.status === 'fulfilled')
        .filter(n => n.value)
        .map(p => p.value.data);
    },
    // parseData() {
    //   this.proplist = this.updateList(r)
    //     .map(n => ({
    //       ...n,
    //       registered: new Date(n.registered),
    //       provided_at: new Date(n.provided_at),
    //       built_at_within: new Date(n.built_at_within),
    //       price_min: parseInt(n.price_min, 10),
    //       land_area_min: parseInt(n.land_area_min, 10),
    //       building_area_min: parseInt(n.building_area_min, 10),
    //       access_time_by_foot_1: parseInt(n.access_time_by_foot_1, 10),
    //     }))
    //     .sort(this.sortProps(this.optionList.sort[this.options.order_fav].field, this.optionList.sort[this.options.order_fav].order))
    //     .slice((this.options.page - 1) * this.options.size, this.options.page * this.options.size);
    // },
    updateData(data) {
      this.viewHistoryList = data.data;
      this.page = data.currentPage;
      this.count = data.found;
      this.pageSize = data.pageSize;
    },
    updatePage(page = 1) {
      let url = location.origin;
      url += '/history/view/';
      // page
      url += `?page=${page}`;

      location.href = url;
    },
    updateList() {
      this.list = this.list.filter((n) => {
        const limit = new Date();
        limit.setDate(limit.getDate() - 16);
        return new Date(n.provided_at) > limit;
      });
      this.$store.commit('setViewHistory', this.list);
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";

.c-favorite {
  background-color: #FAFAFA;
  position: relative;
  &__headArea {
    margin: 25px 0 30px;
  }
  &__headAreaInner {
    display:flex;
    align-items: center;
    justify-content: center;
  }
  &__headText {
    margin-top: 22px;
    width: 100%;
    font-size: 12px;
    line-height: 1.4;
    color: #E83532;
    text-align: center;
  }
  &--alldelete {
    position: absolute;
    right: 0;
    display:flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 144px;
    height: 44px;
    border: 1px solid #CCC;
    border-radius: 22px;
    font-size: 14px;
    z-index:100;
    background-color: #FFF;
    img{
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
  }
  &--heading {
    width:100%;
    text-align: center;
    font-size:20px;
    font-weight: bold;
    padding-top:40px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  &--count {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  &--noprops {
    height:calc(100vh - 365px);
    width: 100%;
    display:flex;
    justify-content: center;
    align-items: center;
  }
  &--list {
    margin: 30px auto;
    width: 720px;
    position: relative;
    &--item {
      position: relative;
      width: 720px;
      // height: 320px;
      padding:20px;
      display:flex;
      justify-content: space-between;
      margin-bottom:20px;
      background-color:#FFF;
      border: 1px solid #CCC;
      border-radius:15px;
      &__card {
        width:346px;
      }
      &__block {
        width: 315px;
        position:relative;
        display: flex;
        align-items: center;
        justify-content: center;
        &__button {
          margin: 10px 0;
          width: 80%;
          .c-button {
            margin-bottom: 10px;
          }
        }
        span {
          position:absolute;
        }
        &__media {
          font-size: 16px;
          top:0;
          left:0;
        }
        &__delete {
          font-size:14px;
          top:0;
          right:0;

          cursor: pointer;
          img {
            width:24px;
            height:24px;
            vertical-align: middle;
          }
        }
        &__provided {
          font-size:12px;
          bottom:18px;
          right:0;
        }
        &__update {
          font-size:12px;
          bottom:0;
          right:0;

        }
      }
    }
  }
  &__favButtonArea {
    position: relative;
  }
  &__balloon {
    position: absolute;
    top: -100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    width: 100%;
    max-width: 320px;
  }
}
.u-mB10 {
  margin-bottom: 10px;
}

@media screen and (max-width: 767px)  {
.c-favorite {
  background-color: #FAFAFA;
  position: relative;
  &--heading {
    margin: 0;
    padding: 0;
  }
  &__headArea {
    margin: 26px 0 20px;
  }
  &__headAreaInner {
    justify-content: space-between;
  }
  &--alldelete {
    position: unset;
    right: unset;
  }
  &--count {
    text-align: right;
    margin: 0;
  }
  &--list {
    margin: auto;
    width: 100%;
    max-width: 960px;
    &--item {
      flex-wrap:wrap;
      width: 100%;
      margin: auto;
      padding: 0;
      margin-bottom: 20px;
      background:0;
      border: 0;
      position: relative;
      &__card {
        display: flex;
        justify-content: center;
        width: 100%;
      }
      &__block {
        width: 346px;
        margin: 10px auto;
        border-bottom: 1px dashed #CCC;
        &__button {
          margin: 40px 0;
          width: 100%;
        }

        &__provided {
          bottom:24px;
        }
        &__update {
          bottom:6px;
        }
      }
    }
  }
}

}

</style>
